import React from 'react'
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';

//const NuDropdown = (props) => {
const ItemRowFile = ({ 
    imagePath = '',
    nombre = '',
    detalle = '',
    estado=0,
    tam = '',//220.25 KB
    progress ='',
    url='',
    handleDel= null, /* */
    urlFile ='',
    }) => {

  const navigate = useNavigate();
  //------------------------------------------------------------------------------

  //let photoBlob=null
  const delete_click=()=>{
    console.log("delete_click")
    handleDel()
  }
  //-----------------------------------------------------------------
  const btn_down_click=(e, urlFile, fileName )=>{
    e.preventDefault();
    console.log(urlFile)
    //navigate(urlFile)
    //saveAs(urlFile, "example.pdf" );
    download2(urlFile, fileName, true)
  }
  //------------------------------------------------------------
  const download2 = async (urlFile, fileName, forceDownload)=> {
    
    if(!forceDownload){
      //----si es imagen muestra en pantalla 
      const link = document.createElement("a")
      link.href = urlFile
      link.download = fileName
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      return;
    }

    //----------forzamos que descargue la imagen
    const iBlob = await fetch(urlFile)
    .then((response)=> response.arrayBuffer())
    .then((buffer)=>new Blob([buffer],{type: "image/jpg"}))

    console.log(iBlob, URL.createObjectURL(iBlob) )
    
    const link = document.createElement('a')
    link.href = URL.createObjectURL(iBlob)
    link.download= fileName;

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
  //-----------------------------------------------------------------
  //---- manejaremos 3 estados
  /*
  0 pendiente
  1 successfully uploaded.  // subio el archivo exitosamente //correcto
  2 Error
  */
  const get_state=( estado )=> {
    
    if ( estado===0 ) {
      return <span className= "badge badge-pill badge-warning">Pendiente</span>;
    }
    if ( estado===1 ) {
      return <span className= "badge badge-pill badge-success">Correcto</span>;
    }
    if ( estado===2 ) {
      return <span className= "badge badge-pill badge-danger">Error</span>;
    }
    return "";
  }
  //----------------------------------------------------------------
  return (
    <tr className="template-upload  image in">
      <td style={{ width: 90 }}>
        <span className="preview">
          
          <img  className="blob-to-image" 
                width="75" height="75"
                src={ url} alt=""></img>
        </span>
      </td>
      <td>
        <p className="name m-0 truncate">{nombre}</p>
        <p className="name m-0">{tam}</p>

        {
          get_state(estado)
        }
      </td>
      <td style={{ width: '100px' }}>
        <p className="size m-0">{detalle}</p>

        <div className="progress progress-striped active" role="progressbar"
          aria-valuemin="0" aria-valuemax="100" aria-valuenow="0">
          <div className="progress-bar progress-bar-success" style={{ width: `${progress}%` }}>
          </div>
        </div>
      </td>

      <td style={{ textAlign: 'center', width: 110}}>
        { estado===1 &&
          <button className="btn btn-success "
                  onClick={(e)=> btn_down_click(e,urlFile,nombre) }>
            <i className="fa fa-download"></i>
          </button>
        }
        {/*<a href={urlFile} download >
          <i className="fa fa-download"></i>
        </a>*/}


        <button className="btn btn-danger cancel" title="Eliminar"
          onClick={ delete_click }
          >
          <i className="fa fa-trash"></i>
          <span></span>
        </button>

      </td>
    </tr>
    
  )
}
export default ItemRowFile;